// this is an autogenerated file from App/Account/Content/Tasks/mutation-delete-task.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Tasks($id: uuid!) {
  update_tasks_tasks_by_pk(pk_columns: { id: $id }, _set: { deleted: true }) {
    id
  }
}

`